import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import cookie from '../../../../util/cookie.js';

import { getProductPriceFromReferralRequest, memoizedGetProducts, setProductSpecialPrice } from '../../ProductActions';

import withRouter from '../../../../components/Router/WithRouter';
import { USER_GROUP_DEFAULT } from '../../../User/UserGroupActions';
import { getHashCode } from '../../../../util/security.js';
import { toDate } from '../../../../util/date.js';

const referrals = [
	{
		name: 'google',
		parameter: 'pv2',
	},
];

function getHashFromSpecialPriceDetails(details) {
	return getHashCode(`${process.env.NODE_ENV}.${details?._id || ''}.${details?.price || ''}.${details?.untilDate}`);
}

function getSpecialPriceFromDetails(details) {
	return {
		key: 'priceTTC',
		value: details.price,
		quantity: 1,
		groups: [USER_GROUP_DEFAULT],
		dateThreshold: details.untilDate,
	};
}

function ProductReferralPrice({ dispatch, search, products }) {
	useEffect(() => {
		if(products.length) {
			referrals.forEach(referral => {
				const referralCookieKey = `referral-${referral.name}-specialprice`;
				if(search.get(referral.parameter)) {
					getProductPriceFromReferralRequest(referral.name, search.get(referral.parameter)).then(details => {
						if(details) {
							cookie.setItem(referralCookieKey, JSON.stringify({ details, hash: getHashFromSpecialPriceDetails(details) }), { maxAge: 2 * 24 * 60 * 60 });
							dispatch(setProductSpecialPrice(details._id, getSpecialPriceFromDetails(details)));
						}
					});
				} else {
					const specialPriceCookie = cookie.getItem(referralCookieKey);
					if(specialPriceCookie) {
						const data = JSON.parse(specialPriceCookie);
						if(data.hash === getHashFromSpecialPriceDetails(data.details)) {
							const { details } = data;
							dispatch(setProductSpecialPrice(details._id, getSpecialPriceFromDetails(details)));
						}
					}
				}
			});
		}
	}, []);

	return null;
}

const mapStateToProps = (store, props) => ({
	products: memoizedGetProducts(store),
});

ProductReferralPrice.propTypes = {
	dispatch: PropTypes.func.isRequired,
	search: PropTypes.object.isRequired,
	products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect(mapStateToProps)(withRouter(ProductReferralPrice));
